import { OfChatMessagesService } from '@api'
import {
  attach,
  combine,
  createEffect,
  createEvent,
  createStore,
  sample,
} from 'effector'
import debounce from 'lodash/debounce'

import { $fanId } from '@/models/chattingUI/chats/chats.ts'
import { $pinnedMessageIdToFetch } from '@/models/chattingUI/messages/pinnedMessages.ts'
import { $creatorId } from '@/models/creators.ts'
import { handleError } from '@/utils/error'

export const resetSearchText = createEvent('set pinned messages search text')
export const setSearchText = createEvent<string>(
  'set pinned messages search text',
)
export const setSearch = debounce(setSearchText, 500)
export const $searchText = createStore<string>('', {
  name: 'pinned messages search text',
})
  .on(setSearchText, (_, text) => text)
  .reset(resetSearchText)

export const searchPinnedTextFx = attach({
  name: 'search fan pinned messages by text',
  source: {
    fanId: $fanId,
    creatorId: $creatorId,
  },
  mapParams: (query: string, { fanId, creatorId }) => {
    return {
      creatorId: creatorId!,
      userId: fanId,
      query,
    }
  },
  effect: createEffect(OfChatMessagesService.getPinnedMessagesQuery),
})

searchPinnedTextFx.failData.watch((error) => {
  handleError(error, 'Something went wrong while searching message')
})

export const $searchedMessageIds = createStore<Nullable<number[]>>(null, {
  name: 'searched pinned message ids',
})
  .on(searchPinnedTextFx.doneData, (_, { list }) => list)
  .reset(resetSearchText)

export const $searchResultIndex = combine(
  $searchedMessageIds,
  $pinnedMessageIdToFetch,
  (messageIds, searchId) => {
    return searchId && messageIds ? messageIds.indexOf(searchId) : -1
  },
)

sample({
  clock: $searchText,
  filter: (text) => !!text,
  target: searchPinnedTextFx,
})
